var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-better-new-scroll',{ref:"scroll",staticClass:"wrapper",attrs:{"scrollbar":_vm.scrollbarObj,"pullDownRefresh":_vm.pullDownRefreshObj,"startY":parseInt(_vm.startY)},on:{"pullingDown":_vm.onPullingDown}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }